module.exports = __webpack_public_path__ + "img/CO.283489ce.webp";